import classnames from 'clsx';
import PropTypes from 'prop-types';
import { player } from 'src/client/player';
import { useStores } from 'src/common/providers';
import cssVariables from '../../../styles/variables';
import Checkmark from '../../shared/svgIcons/Checkmark';
import css from './playback-rate-option.module.scss';

export default function PlayBackRateOption({ value, className }) {
  const { playerStore } = useStores();
  const playbackRate = playerStore.playbackRate();
  const formattedPlaybackRate = `${value.toString().padEnd(3, '.0')}x`;

  return (
    <div className={classnames(css.value, className)} onClick={() => player.setPlaybackRate(value)}>
      {formattedPlaybackRate}
      {value === playbackRate && (
        <Checkmark
          width="40px"
          height="40px"
          viewBox="0 0 30 30"
          fill={cssVariables['--secondary-color-5']}
        />
      )}
    </div>
  );
}

PlayBackRateOption.propTypes = {
  value: PropTypes.number,
  className: PropTypes.string,
};
